import { isValidDate } from 'pages/scenario/utils/isValidDate';

export const tryParseDateToISO = (date: any): string => {
    if (isValidDate(date)) return new Date(date).toISOString().split('T')[0];
    return '';
};

export default tryParseDateToISO;